export const PodTypesList = [
  {
    label: 'Focus',
    value: 'focus',
    name: 'Focus'
  },
  {
    label: 'Breathe',
    value: 'breathe',
    name: 'Breathe',
    mode: [
      {
        label: 'Exercises',
        value: 'exercises'
      },
      {
        label: 'Expert Content',
        value: 'expert_content'
      }
    ]
  },
  {
    label: 'Relax',
    value: 'relax',
    name: 'Relax'
  },
  {
    label: 'Calm',
    value: 'calm',
    name: 'Calm'
  }
];
